import React from "react";
import {
  ContentSection,
  FlexColumn,
  TextOnlyButton,
  FlexRow,
  LargeButton,
  LargeButtonSecondary,
  ButtonText,
  SlideUpModal,
  ModalOverlay,
  FormInputField,
  Text,
  Accordion,
  FormSelectField,
  QuickToggleButton,
} from "../styles/Global";
import * as Global from "../styles/Global";
import { useSelector } from "react-redux";

const QuickToggle = ({
  option1,
  option2,
  style,
  color,
  selected,
  setSelected,
  border,
  selectorColor,
  disabled,
  textColor,
  customDispatch,
  fontSize,
}) => {
  // console.log("quicktoggle disabled: ", disabled);
  // console.log("quicktoggle textColor: ", textColor);
  const darkMode = useSelector((state) => state.global.darkMode);
  return (
    <QuickToggleButton
      className="contentBackgroundColor"
      type="button"
      justify="space-between"
      color={color}
      border={border}
      style={style}
      onClick={() =>
        disabled
          ? null
          : customDispatch
          ? customDispatch()
          : setSelected(!selected)
      }
    >
      <Text
        className={
          !selected ? "mainFontColorQuickToggle" : "mainFontColorLight"
        }
        size={fontSize ? fontSize : ".65em"}
        style={{
          textTransform: "uppercase",
          fontWeight: "600",
          textAlign: "center",
          width: "50%",
        }}
        color={!selected && textColor ? textColor : null}
      >
        {option1}
      </Text>
      {typeof option2 === "string" ? (
        <Text
          className={
            !selected ? "mainFontColorQuickToggle" : "mainFontColorLight"
          }
          size={fontSize ? fontSize : ".65em"}
          style={{
            textTransform: "uppercase",
            fontWeight: "600",
            textAlign: "center",
            width: "50%",
          }}
          color={!selected && textColor ? textColor : null}
        >
          {option2}
        </Text>
      ) : (
        option2
      )}
      <div
        className={`quickToggleSelector ${selected && "quickToggleSelected"}`}
        style={{
          backgroundColor:
            selectorColor || (darkMode ? `${Global.redLight}99` : "#CC0C0D35"),
        }}
      />
    </QuickToggleButton>
  );
};

export default QuickToggle;
